export enum ErrorsCodesEnum {
    ECONNREFUSED = 5000,
    ERR_BAD_RESPONSE = 5001,
    INTERNAL_SERVER_ERROR = 5002,
    ERR_BAD_REQUEST = 5003,
    OPERATION_RESOLUTION_FAILURE = 5004,
    PERSISTED_QUERY_NOT_SUPPORTED = 5005,
    PERSISTED_QUERY_NOT_FOUND = 50006,
    BAD_USER_INPUT = 5007,
    GRAPHQL_VALIDATION_FAILED = 5008,
    GRAPHQL_PARSE_FAILED = 5009,
    FORBIDDEN = 5010,
    DUPLICATED_TRIP_CODE = 5011,
    DUPLICATED_CODE = 5011,
    DUPLICATED_EXTERNAL_ID = 5011,
    DUPLICATED_LICENSE_PLATE = 5011,
    DUPLICATED_ORGANIZATION_ID = 5011,
    DUPLICATED_PHONE_NUMBER = 5011,
    CONFLICT = 5012,
    TOO_MANY_REQUESTS = 5013,
    QUANTITY_LIMIT_EXCEEDED = 5014,
    NOT_IN_ORGANIZATION_CARRIERS = 5015,
    UNKNOWN_ERROR = 7000,
}

export enum ErrorsNamesEnum {
    ECONNREFUSED = 'ECONNREFUSED',
    ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE',
    BAD_REQUEST = 'BAD_REQUEST',
    INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
    ERR_BAD_REQUEST = 'ERR_BAD_REQUEST',
    OPERATION_RESOLUTION_FAILURE = 'OPERATION_RESOLUTION_FAILURE',
    PERSISTED_QUERY_NOT_SUPPORTED = 'PERSISTED_QUERY_NOT_SUPPORTED',
    PERSISTED_QUERY_NOT_FOUND = 'PERSISTED_QUERY_NOT_FOUND',
    BAD_USER_INPUT = 'BAD_USER_INPUT',
    GRAPHQL_VALIDATION_FAILED = 'GRAPHQL_VALIDATION_FAILED',
    GRAPHQL_PARSE_FAILED = 'GRAPHQL_PARSE_FAILED',
    FORBIDDEN = 'FORBIDDEN',
    DUPLICATED_TRIP_CODE = 'DUPLICATED_TRIP_CODE',
    CONFLICT = 'CONFLICT',
    DUPLICATED_EXTERNAL_ID = 'DUPLICATED_EXTERNAL_ID',
    DUPLICATED_ORGANIZATION_ID = 'DUPLICATED_ORGANIZATION_ID',
    DUPLICATED_CODE = 'DUPLICATED_CODE',
    DUPLICATED_VAT_NUMBER = 'DUPLICATED_VAT_NUMBER',
    DUPLICATED_LICENSE_PLATE = 'DUPLICATED_LICENSE_PLATE',
    DUPLICATED_NAME = 'DUPLICATED_NAME',
    DUPLICATED_PHONE_NUMBER = 'DUPLICATED_PHONE_NUMBER',
    PHONE_NUMBER_ALREADY_EXISTS = 'PHONE_NUMBER_ALREADY_EXISTS',
    DRIVER_IN_OTHER_ORGANIZATION = 'DRIVER_IN_OTHER_ORGANIZATION',
    MISSING_PERMISSIONS_ERROR = 'MISSING_PERMISSIONS_ERROR',
    DUPLICATED_LOCATION_CODE = 'DUPLICATED_LOCATION_CODE',
    LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND',
    DUPLICATED_VEHICLE_DEVICE = 'DUPLICATED_VEHICLE_DEVICE',
    TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
    QUANTITY_LIMIT_EXCEEDED = 'QUANTITY_LIMIT_EXCEEDED',
    QUOTA_LIMIT_EXCEEDED = 'QUOTA_LIMIT_EXCEEDED',
    NOT_IN_ORGANIZATION_CARRIERS = 'NOT_IN_ORGANIZATION_CARRIERS',
    TACHOGRAPH_FILES_NOT_FOUND = 'TACHOGRAPH_FILES_NOT_FOUND',
}

export enum ErrorMessagesEnum {
    INVALID_TOKEN = 'No token was found in the request',
    UNAUTHORIZED = 'Unauthorized',
    INVITE_NOT_FOUND = 'Invite not found',
    USER_NOT_FOUND = 'User not found',
    TRIP_DEFINITION_ID_NOT_FOUND_AT_HELPER = 'Cant find tripDefinition id at trip helper',
}
